var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-chip tw-rounded tw-font-medium tw-px-2 tw-py-1 tw-text-center",class:{
    'white tw-bg-white tw-text-secondary-text': _vm.white,
    'tw-bg-blue-500 tw-text-white': !_vm.white
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }